export const TEST_ID = 'detailsViewCard';
